import { types } from "mobx-state-tree";
import { withSetPropAction } from "./helpers/withSetPropAction";

export const AboutUsModel = types
  .model("AboutUsStore")
  .props({
    detailId: types.optional(types.integer, 0),
  })
  .actions(withSetPropAction)
  .actions((self) => ({
    setDetailId(id: number) {
      self.detailId = id;
    },
  }));
